angular.module('gym.bulkImports').directive('bulkImportComplete', function() {
  return {
    restrict: 'E',
    template: require('templates/gyms/bulkImports/show/bulkImportComplete.html.slim'),
    scope: {
      bulkImport: '=',
      visible: '=',
      cancel: '&',
      retry: '&',
      selectFile: '&'
    },
    controller: ["$scope", "ngTableParams", "$filter", function($scope, ngTableParams, $filter) {
      var init;
      init = function() {
        $scope.rowsWithErrors = $scope.bulkImport.all('rows').getList({
          count: 1000,
          'filters[save_failures_only]': true
        }).$object;
        return $scope.createdRowCount = $scope.bulkImport.all('rows').getList({
          count: 1000,
          'filters[not_ignored]': true
        }).then(function(data) {
          return $scope.createdRowCount = data.meta.total;
        });
      };
      $scope.$watch('visible', function(visible, previousVisible) {
        if (visible && !previousVisible && $scope.tableParams) {
          return init();
        }
      });
      $scope.$watch('bulkImport.status', function(status, prev) {
        if ($scope.visible && status !== prev && $scope.tableParams) {
          return $scope.tableParams.reload();
        }
      });
      init();
      $scope.isInProgress = function() {
        var ref;
        return (ref = $scope.bulkImport.status) === 'queued_for_import' || ref === 'importing';
      };
      $scope.submitRetry = function() {
        return $scope.retry().then(function() {
          return init();
        }, function() {
          return init();
        });
      };
      $scope.contactType = function(row) {
        return $filter('underscored')(row.type) + 's';
      };
      return $scope.tableParams = new ngTableParams({
        page: 1,
        count: 20
      }, {
        counts: [],
        total: 0,
        getData: function($defer, $params) {
          if (!$scope.visible) {
            return;
          }
          return $scope.bulkImport.all('records').getList($params.url()).then(function(data) {
            $params.total(data.meta.total);
            $scope.totalCreated = data.meta.total;
            return $defer.resolve(data);
          });
        }
      });
    }]
  };
});
